/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  ChangeAtmPinResponse,
  ChangeAtmPinRequest,
  SetCardNotificationSettingResponse,
  SetCardNotificationSettingRequest,
  GetCardNotificationSettingResponse,
  GetCardAccountsResponse,
  UtxCardGetCardAccountsParams,
  SpendingControlResponse,
  SpendingControlRequest,
  ValidateCVC2Response,
  ValidateCVC2Request,
  ActivationCardResponse,
  ActivationCardRequest,
  ActivationAtmPinResponse,
  ActivationAtmPinRequest,
  LockCardResponse,
  LockCardRequest
} from './schema'



export const utxCardChangeAtmPin = (
    id: string,
    changeAtmPinRequest: ChangeAtmPinRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ChangeAtmPinResponse>> => {
    return axios.post(
      `/card/${id}/change-atm-pin`,
      changeAtmPinRequest,options
    );
  }



    export type UtxCardChangeAtmPinMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardChangeAtmPin>>>
    export type UtxCardChangeAtmPinMutationBody = ChangeAtmPinRequest
    export type UtxCardChangeAtmPinMutationError = AxiosError<unknown>

    export const useUtxCardChangeAtmPin = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardChangeAtmPin>>, TError,{id: string;data: ChangeAtmPinRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardChangeAtmPin>>, {id: string;data: ChangeAtmPinRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  utxCardChangeAtmPin(id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardChangeAtmPin>>, TError, {id: string;data: ChangeAtmPinRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardChangeAtmPinWithScope = (
    id: string,
    changeAtmPinRequest: ChangeAtmPinRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ChangeAtmPinResponse>> => {
    return axios.post(
      `/card/${id}/change-atm-pin-v2`,
      changeAtmPinRequest,options
    );
  }



    export type UtxCardChangeAtmPinWithScopeMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardChangeAtmPinWithScope>>>
    export type UtxCardChangeAtmPinWithScopeMutationBody = ChangeAtmPinRequest
    export type UtxCardChangeAtmPinWithScopeMutationError = AxiosError<unknown>

    export const useUtxCardChangeAtmPinWithScope = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardChangeAtmPinWithScope>>, TError,{id: string;data: ChangeAtmPinRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardChangeAtmPinWithScope>>, {id: string;data: ChangeAtmPinRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  utxCardChangeAtmPinWithScope(id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardChangeAtmPinWithScope>>, TError, {id: string;data: ChangeAtmPinRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardSetCardNotificationSetting = (
    id: string,
    setCardNotificationSettingRequest: SetCardNotificationSettingRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SetCardNotificationSettingResponse>> => {
    return axios.post(
      `/card/${id}/card-notification-setting`,
      setCardNotificationSettingRequest,options
    );
  }



    export type UtxCardSetCardNotificationSettingMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardSetCardNotificationSetting>>>
    export type UtxCardSetCardNotificationSettingMutationBody = SetCardNotificationSettingRequest
    export type UtxCardSetCardNotificationSettingMutationError = AxiosError<unknown>

    export const useUtxCardSetCardNotificationSetting = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardSetCardNotificationSetting>>, TError,{id: string;data: SetCardNotificationSettingRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardSetCardNotificationSetting>>, {id: string;data: SetCardNotificationSettingRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  utxCardSetCardNotificationSetting(id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardSetCardNotificationSetting>>, TError, {id: string;data: SetCardNotificationSettingRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardGetCardNotificationSetting = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetCardNotificationSettingResponse>> => {
    return axios.get(
      `/card/${id}/card-notification-setting`,options
    );
  }


export const getUtxCardGetCardNotificationSettingQueryKey = (id: string,) => [`/card/${id}/card-notification-setting`];

    
export type UtxCardGetCardNotificationSettingQueryResult = NonNullable<Awaited<ReturnType<typeof utxCardGetCardNotificationSetting>>>
export type UtxCardGetCardNotificationSettingQueryError = AxiosError<unknown>

export const useUtxCardGetCardNotificationSetting = <TData = Awaited<ReturnType<typeof utxCardGetCardNotificationSetting>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCardGetCardNotificationSetting>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCardGetCardNotificationSettingQueryKey(id);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCardGetCardNotificationSetting>>> = ({ signal }) => utxCardGetCardNotificationSetting(id, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCardGetCardNotificationSetting>>, TError, TData>(queryKey, queryFn, {enabled: !!(id), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxCardGetCardAccounts = (
    params: UtxCardGetCardAccountsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetCardAccountsResponse>> => {
    return axios.get(
      `/card/accounts`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxCardGetCardAccountsQueryKey = (params: UtxCardGetCardAccountsParams,) => [`/card/accounts`, ...(params ? [params]: [])];

    
export type UtxCardGetCardAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof utxCardGetCardAccounts>>>
export type UtxCardGetCardAccountsQueryError = AxiosError<unknown>

export const useUtxCardGetCardAccounts = <TData = Awaited<ReturnType<typeof utxCardGetCardAccounts>>, TError = AxiosError<unknown>>(
 params: UtxCardGetCardAccountsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCardGetCardAccounts>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCardGetCardAccountsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCardGetCardAccounts>>> = ({ signal }) => utxCardGetCardAccounts(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCardGetCardAccounts>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxCardSpendingControl = (
    id: string,
    spendingControlRequest: SpendingControlRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SpendingControlResponse>> => {
    return axios.post(
      `/card/${id}/spending-control`,
      spendingControlRequest,options
    );
  }



    export type UtxCardSpendingControlMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardSpendingControl>>>
    export type UtxCardSpendingControlMutationBody = SpendingControlRequest
    export type UtxCardSpendingControlMutationError = AxiosError<unknown>

    export const useUtxCardSpendingControl = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardSpendingControl>>, TError,{id: string;data: SpendingControlRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardSpendingControl>>, {id: string;data: SpendingControlRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  utxCardSpendingControl(id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardSpendingControl>>, TError, {id: string;data: SpendingControlRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Validate CVC2 before the card activation process
 */
export const utxCardActivationValidateCVC2 = (
    id: string,
    validateCVC2Request: ValidateCVC2Request, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ValidateCVC2Response>> => {
    return axios.post(
      `/card/${id}/activation-cvc2-verify`,
      validateCVC2Request,options
    );
  }



    export type UtxCardActivationValidateCVC2MutationResult = NonNullable<Awaited<ReturnType<typeof utxCardActivationValidateCVC2>>>
    export type UtxCardActivationValidateCVC2MutationBody = ValidateCVC2Request
    export type UtxCardActivationValidateCVC2MutationError = AxiosError<unknown>

    export const useUtxCardActivationValidateCVC2 = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardActivationValidateCVC2>>, TError,{id: string;data: ValidateCVC2Request}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardActivationValidateCVC2>>, {id: string;data: ValidateCVC2Request}> = (props) => {
          const {id,data} = props ?? {};

          return  utxCardActivationValidateCVC2(id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardActivationValidateCVC2>>, TError, {id: string;data: ValidateCVC2Request}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Step 1 for card activation process
 */
export const utxCardActivationActivateCard = (
    id: string,
    activationCardRequest: ActivationCardRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ActivationCardResponse>> => {
    return axios.post(
      `/card/${id}/activation`,
      activationCardRequest,options
    );
  }



    export type UtxCardActivationActivateCardMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardActivationActivateCard>>>
    export type UtxCardActivationActivateCardMutationBody = ActivationCardRequest
    export type UtxCardActivationActivateCardMutationError = AxiosError<unknown>

    export const useUtxCardActivationActivateCard = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardActivationActivateCard>>, TError,{id: string;data: ActivationCardRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardActivationActivateCard>>, {id: string;data: ActivationCardRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  utxCardActivationActivateCard(id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardActivationActivateCard>>, TError, {id: string;data: ActivationCardRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Activation step 2 set ATM pin
 */
export const utxCardActivationActivationAtmPin = (
    id: string,
    activationAtmPinRequest: ActivationAtmPinRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ActivationAtmPinResponse>> => {
    return axios.post(
      `/card/${id}/activation-atm-pin`,
      activationAtmPinRequest,options
    );
  }



    export type UtxCardActivationActivationAtmPinMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardActivationActivationAtmPin>>>
    export type UtxCardActivationActivationAtmPinMutationBody = ActivationAtmPinRequest
    export type UtxCardActivationActivationAtmPinMutationError = AxiosError<unknown>

    export const useUtxCardActivationActivationAtmPin = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardActivationActivationAtmPin>>, TError,{id: string;data: ActivationAtmPinRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardActivationActivationAtmPin>>, {id: string;data: ActivationAtmPinRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  utxCardActivationActivationAtmPin(id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardActivationActivationAtmPin>>, TError, {id: string;data: ActivationAtmPinRequest}, TContext>(mutationFn, mutationOptions)
    }
    export const utxCardLockSetLock = (
    id: string,
    lockCardRequest: LockCardRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LockCardResponse>> => {
    return axios.post(
      `/card/${id}/lock`,
      lockCardRequest,options
    );
  }



    export type UtxCardLockSetLockMutationResult = NonNullable<Awaited<ReturnType<typeof utxCardLockSetLock>>>
    export type UtxCardLockSetLockMutationBody = LockCardRequest
    export type UtxCardLockSetLockMutationError = AxiosError<unknown>

    export const useUtxCardLockSetLock = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxCardLockSetLock>>, TError,{id: string;data: LockCardRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxCardLockSetLock>>, {id: string;data: LockCardRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  utxCardLockSetLock(id,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxCardLockSetLock>>, TError, {id: string;data: LockCardRequest}, TContext>(mutationFn, mutationOptions)
    }
    